import styled from 'styled-components';
import { useProductOptionsValueContextHook } from '../../../../contexts/ProductOptionsContext';

const StyledTableCell = styled.td`
  padding: 16px;
  color: #495057;
  border-bottom: 1px solid #dee2e6;

  .info-box{
    display: flex;
    flex-direction: column;
    gap: 3px;
    font-size: 12px;
    font-weight: 600;
  }
`

export function TdProductInfo({
    returnExchange
}) {
    const productOptionsValueContextHook = useProductOptionsValueContextHook();
    const productOptions = productOptionsValueContextHook?.productOptions;
    const productOption = productOptions?.find(option => option.code === returnExchange?.releaseOptionCode);

    return (
        <>
            <StyledTableCell>
                <div className='info-box'>
                    <div>상품명: {productOption?.product?.name || '-'}</div>
                    <div>옵션명: {productOption?.name || '-'}</div>
                    <div>수량: {returnExchange?.unit ?? '0'}</div>
                </div>  
            </StyledTableCell>
        </>
    );
}